var _path, _path2, _g, _path3, _g2, _path4, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoHalfWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 39,
    viewBox: "0 0 48 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_226_10651)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.4838 25.1667L37.4258 15.1068C37.7555 14.435 36.9243 13.7705 36.1495 14.0919C34.7863 14.6569 32.9912 15.1543 31.0204 15.1543C29.0382 15.1543 27.2246 14.6519 25.8481 14.0829C25.0746 13.7627 24.2454 14.4272 24.5738 15.0984L29.5218 25.1667C30.0684 26.2778 31.9371 26.2778 32.4838 25.1667Z",
    fill: "#EE4322"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_226_10651",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 14,
    width: 14,
    height: 13
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 14.0276H23.2387V26.3808H10.5V14.0276Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_226_10651)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4164 14.8857L10.5726 25.2413C10.2495 25.9333 11.0653 26.6168 11.8245 26.2866C13.1596 25.7044 14.9172 25.1912 16.849 25.1912C18.7912 25.1912 20.5689 25.709 21.9183 26.2958C22.6762 26.6248 23.4894 25.9402 23.1657 25.2493L18.3167 14.8857C17.783 13.7415 15.9507 13.7415 15.4164 14.8857Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_226_10651",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 29,
    y: 8,
    width: 6,
    height: 5
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.6416 8.13245H34.3022V12.761H29.6416V8.13245Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_226_10651)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.3022 10.4469C34.3022 9.16777 33.2579 8.13208 31.971 8.13208C30.686 8.13208 29.6416 9.16777 29.6416 10.4469C29.6416 11.7241 30.686 12.761 31.971 12.761C33.2579 12.761 34.3022 11.7241 34.3022 10.4469Z",
    fill: "#EE4322"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_226_10651",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 8,
    width: 6,
    height: 5
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.5466 8.13245H19.4992V12.761H14.5466V8.13245Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_226_10651)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4992 10.4469C19.4992 9.16777 18.3902 8.13208 17.0223 8.13208C15.6563 8.13208 14.5466 9.16777 14.5466 10.4469C14.5466 11.7241 15.6563 12.761 17.0223 12.761C18.3902 12.761 19.4992 11.7241 19.4992 10.4469Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_226_10651",
    x: 0.5,
    y: 0.132446,
    width: 47,
    height: 38.2484,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_226_10651"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_226_10651",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHalfWhite);
export default __webpack_public_path__ + "static/media/logo-half-white.8aafe5a6a6457465e9c99e3d4a7dd794.svg";
export { ForwardRef as ReactComponent };